(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name vcuser.user.factory:User
     *
     * @description
     *
     */
    angular
        .module('vcuser.vcuser')
        .factory('User', User);


    User.$inject = ['restmod'];

    function User(restmod) {
        return restmod.model('/routes/users').mix({
            created: {
                init: function () {
                    return moment().toISOString();
                }
            },
            active: {init: true},
            $extend: {
                Model: {
                    $searchahead: function (_params) {
                        return this.$collection().$decorate({
                            'before-request': function (_req) {
                                _req.method = 'GET';
                                _req.url = '/routes/user/searchahead';
                            }
                        }, function () {
                            return this.$fetch(_params);
                        });
                    },
                    $searchBy: function (key, val) {
                        var tmp = {};
                        tmp[key] = val;
                        return this.$search({query: tmp});
                    }
                } // Model
            }// extend
        });
    }

// klammerfriedhof
}());
